import EditCollection from "./EditCollection";
export default EditCollection;